export const QUICK_REPLY_VARIABLES = [
    {
        key: 'customer_name',
        label: 'Customer name',
        description: 'Name of the person who submitted or owns the ticket',
        example: 'John Doe',
    },
    {
        key: 'customer_email',
        label: 'Customer email',
        description: 'Email address of the ticket requester',
        example: 'john@example.com',
    },
    {
        key: 'my_name',
        label: 'Your name',
        description: 'Name of the logged-in agent',
        example: 'Saimir',
    },
    {
        key: 'my_email',
        label: 'Your email',
        description: 'Email of the logged-in agent',
        example: 'saimir@company.com',
    },
    {
        key: 'ticket_id',
        label: 'Ticket ID',
        description: 'Public ticket reference number',
        example: '#1042',
    },
    {
        key: 'ticket_title',
        label: 'Ticket title',
        description: 'Subject or title of the ticket',
        example: 'Login issue',
    },
];

export function quickReplyPlaceholder(key) {
    return `{{${key}}}`;
}

export function resolveQuickReplyContent(content, { ticket, user } = {}) {
    if (!content) {
        return '';
    }

    const recipient = ticket?.created_by ?? {};
    const ticketRef = ticket?.ticket_id ?? ticket?.id;

    const values = {
        customer_name: recipient?.name ?? '',
        customer_email: recipient?.email ?? '',
        person_name: recipient?.name ?? '',
        person_email: recipient?.email ?? '',
        my_name: user?.name ?? '',
        my_email: user?.email ?? '',
        ticket_id: ticketRef ? `#${ticketRef}` : '',
        ticket_title: ticket?.title ?? '',
    };

    let result = content;
    Object.entries(values).forEach(([key, value]) => {
        const pattern = new RegExp(`\\{\\{\\s*${key}\\s*\\}\\}`, 'gi');
        result = result.replace(pattern, value);
    });

    return result;
}

export function decodeHtmlEntities(text) {
    if (!text) {
        return '';
    }
    if (typeof document !== 'undefined') {
        const el = document.createElement('textarea');
        el.innerHTML = text;
        return el.value;
    }
    return String(text)
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
}

export function stripHtmlPreview(html, maxLength = 80) {
    const withoutTags = String(html ?? '').replace(/<[^>]*>/g, ' ');
    const plain = decodeHtmlEntities(withoutTags).replace(/\s+/g, ' ').trim();

    if (plain.length <= maxLength) {
        return plain;
    }

    return `${plain.slice(0, maxLength).trimEnd()}...`;
}
